exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading-container[data-v-1c3b0ee9]{padding:20px}", "", {"version":3,"sources":["/workspace/src/views/invoice-apply/pages/InvoiceDetailRedirect.vue"],"names":[],"mappings":"AACA,oCAAoC,YAAY,CAC/C","file":"InvoiceDetailRedirect.vue","sourcesContent":["\n.loading-container[data-v-1c3b0ee9]{padding:20px\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c3b0ee9","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/invoice-apply/pages/InvoiceDetailRedirect.vue
// module id = 4281
// module chunks = 351